import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AddDevicePage } from './add-device/add-device.page';
import { DevicesService } from './services/devices.service';
import { HttpService } from './services/http.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  devices = [];
  currentUser: any = null;

  constructor(
    private deviceService: DevicesService,
    private modelController: ModalController,
    private httpService: HttpService,
    private router: Router
  ) {}

  ngOnInit() {
    this.httpService.user.subscribe((u) => {
      this.currentUser = u;
    });
    this.autoLogin();

    if (this.httpService.isUserAuthorize) {
      this.fetchDevices();
    }
  }

  fetchDevices() {
    this.deviceService.getDevice().subscribe({
      next: (data: any) => {
        if (data) {
          this.devices = data.data;
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  setActiveDevice(device: any) {
    this.deviceService.setCurrentDevice(device);
  }

  async addNewDevice() {
    const modal = await this.modelController.create({
      component: AddDevicePage,
      animated: true,
      showBackdrop: true,
    });

    await modal.present();
  }

  onChangeSideMenu() {
    this.fetchDevices();
  }

  async autoLogin() {
    const token = await this.httpService.getTokenFromStore();

    if (token.value) {
      this.httpService.setToken(token.value);
      this.httpService.doGet('/autMe', {}).subscribe({
        next: (data: any) => {
          if (data.success && data.token) {
            this.httpService.setToken(data.token);
            this.httpService.isUserAuthorize = true;
            this.httpService.user.next(data.data);
            this.router.navigate(['/dashboard']);
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }

  logout() {
    this.httpService.clearToken();
    this.httpService.isUserAuthorize = false;
    this.httpService.user.next(null);
    this.router.navigate(['/login']);
  }
}
